import { render, staticRenderFns } from "./FormatSettings.vue?vue&type=template&id=f41a2f96&scoped=true"
import script from "./FormatSettings.vue?vue&type=script&lang=js"
export * from "./FormatSettings.vue?vue&type=script&lang=js"
import style0 from "./FormatSettings.vue?vue&type=style&index=0&id=f41a2f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41a2f96",
  null
  
)

export default component.exports